import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { getGaClientId } from '~/helpers/client/cookie';
import { orchestration } from '~/config/public';
import { Bid } from '~/App/shared/interfaces/Bid';

export interface PlaceBidArgs {
  amount: number;
  auctionId: string;
}
export const placeBid = ({ amount, auctionId }: PlaceBidArgs) => {
  return axios.post(
    `${orchestration.url}/auction/auctions/${auctionId}/max-bids`,
    {
      maxBid: {
        amount: amount
      },
      GaClientId: getGaClientId()
    },
    {
      withCredentials: true,
      responseType: 'json'
    }
  );
};

export interface EditMaxBidInput {
  amount: number;
  maxBidId: number;
  auctionId: string;
}
export const editMaxBid = ({ amount, auctionId, maxBidId }: EditMaxBidInput) =>
  axios.put(
    `${orchestration.url}/auction/auctions/${auctionId}/max-bids/${maxBidId}`,
    {
      maxBid: {
        amount: amount
      },
      GaClientId: getGaClientId()
    },
    {
      withCredentials: true,
      responseType: 'json'
    }
  );

export interface GetBrandsResponse {
  brands: {
    [key: string]: string[];
  };
}
export const getBrands = (params = {}) =>
  axios
    .get<GetBrandsResponse>(`${orchestration.url}/auction/brands`, {
      params: params,
      responseType: 'json'
    })
    .then(({ data }) => data.brands);

export const getAuctionSlugByProcessObjectId = (processObjectId: string) =>
  axios
    .get<string>(
      `${orchestration.url}/auction/auction_url/by_process_object_id/${processObjectId}`,
      {
        responseType: 'json'
      }
    )
    .then(({ data }) => data);

export const getAuctionBids = (auctionId: string) => {
  return axios
    .get<{ bids: Bid[] }>(
      `${orchestration.url}/auction/auctions/${auctionId}/bids`,
      {
        withCredentials: true,
        responseType: 'json'
      }
    )
    .then(({ data }) => data);
};
